var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkUploadRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.69196 8.04306L0.33566 7.40915C1.26115 3.96802 3.97223 1.25817 7.41091 0.336824C10.9357 -0.607209 14.6448 0.483468 17.1213 2.97861L17.2831 1.12933C17.3183 0.728199 17.675 0.428812 18.0761 0.463948L19.0482 0.54886C19.4493 0.58424 19.7487 0.940723 19.7138 1.34186L19.1822 7.41866C19.1705 7.55237 19.0516 7.65217 18.9179 7.64046L12.8411 7.10878C12.44 7.07365 12.1406 6.71692 12.1755 6.31578L12.2606 5.3432C12.2958 4.94207 12.6525 4.64292 13.0536 4.67782L15.5837 4.89912C13.7151 2.86539 10.804 1.95332 8.04214 2.69361C5.44232 3.39048 3.392 5.44031 2.69196 8.04306ZM11.9576 17.3062C9.19576 18.0468 6.28461 17.1345 4.41606 15.1007L6.94609 15.322C7.34722 15.3572 7.70395 15.0578 7.73909 14.6567L7.82424 13.6841C7.85938 13.2829 7.55999 12.9262 7.15861 12.8911L1.08205 12.3596C0.948342 12.3479 0.829514 12.4477 0.817802 12.5814L0.286128 18.6582C0.250992 19.0594 0.550379 19.4159 0.951758 19.4512L1.92385 19.5362C2.32499 19.5715 2.68171 19.2719 2.71685 18.8708L2.87935 17.0154C4.75912 18.9108 7.34625 20 10.0276 20C10.8789 20 11.7397 19.8907 12.5893 19.663C16.028 18.7417 18.7391 16.0316 19.6643 12.591L17.308 11.957C16.608 14.56 14.5579 16.6099 11.9576 17.3062Z",
    fill: "#1D3679"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUploadRefresh);
export default __webpack_public_path__ + "static/media/bulkUploadRefresh.c4af7d2f571f379f9d0db3cc8b3ab055.svg";
export { ForwardRef as ReactComponent };